<template>
  <Stage>
    <img
      class="gng-img"
      :src="getImageUrl(neutralImage)"
      v-if="showDelay"
    />
    <img
      class="gng-img"
      :src="getImageUrl(gngImage)"
      v-else
    />

    <Button exam :keys="['enter']" @keydown="handleKeyboard" disableMouse />
  </Stage>
</template>

<script>
import { Stage, Button } from '@neurotrack/web-shared-components'
import essComponentProps from '@/mixins/essComponentProps'

export default {
  mixins: [essComponentProps],
  components: { Stage, Button },
  data() {
    return {
      showDelay: true,
      delayTimer: undefined,
      timer: undefined,
      lastTime: 0
    }
  },
  computed: {
    type() {
      return this.trial?.trial_scoring_type
    },
    gngImage() {
      return this.trialData?.body?.trial_image?.filename
    },
    neutralImage() {
      return this.trialData?.body?.delay_image?.filename
    },
    delayTime() {
      const delay = this.trial?.delay_display_seconds ?? 5
      return delay * 1000 // need millis
    },
    answerTimerDur() {
      return 2000 // timer for coloured light is always 2s
    }
  },
  methods: {
    handleKeyboard(e) {
      if (!this.answered) {
        this.keypressed = e.code.toLowerCase()
        if (this.keypressed === 'enter') {
          clearTimeout(this.timer)
          this.timer = null

          this.answered = true
          this.checkResponseAndEmitAnswer(true)
        }
      }
    },
    checkResponseAndEmitAnswer(wasClicked) {
      let response = wasClicked ? 'go' : 'no_go'

      if (this.showDelay) {
        clearTimeout(this.delayTimer)
        this.delayTimer = undefined
        response = 'early'
      }

      this.$emit('answered', response)
      this.handleTrialResponse({
        response,
        type: this.trial?.trial_scoring_type
      })
    },
    delay() {
      this.delayTimer = setTimeout(() => {
        this.showDelay = false
        this.answerTimer()
      }, this.delayTime)
    },
    answerTimer() {
      this.timer = setTimeout(() => {
        this.answered = true
        if (!this.modalVisible) {
          this.answered = true
          this.checkResponseAndEmitAnswer(false)
        }
      }, this.answerTimerDur)
    }
  },
  watch: {
    // unset values on new trial loaded
    trial: {
      immediate: true,
      handler() {
        clearTimeout(this.timer)
        this.timer = null
        this.keypressed = ''
        this.answered = false
        this.showDelay = true
        this.delay()
      }
    }
  }
}
</script>

<style>
.gng-img {
  width: 20rem;
}
</style>
